import { JsonProperty } from '../../core/services/utils/mapping.service';
import { Category, CategoryFilter } from './category.model';
import { Product } from './product.model';

export class Suggestions {
  @JsonProperty({ clazz: Category, name: 'categories' })
  categories: Category[] = [];
  @JsonProperty({ clazz: CategoryFilter, name: 'subcategories' })
  subcategories: CategoryFilter[] = [];
  @JsonProperty({ clazz: Product, name: 'products' })
  products: Product[] = [];
}
